module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ovalLabel"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6e2e67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/ovalLabel/OvalLabel.vue
// module id = 1829
// module chunks = 0